var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7266 9.66406C20.0938 9.29688 20.0938 8.70312 19.7266 8.33984L14.7266 3.33594C14.3594 2.96875 13.7656 2.96875 13.4023 3.33594C13.0391 3.70312 13.0352 4.29687 13.4023 4.66016L16.8008 8.05859L7.1875 8.0625C6.66797 8.0625 6.25 8.48047 6.25 9C6.25 9.51953 6.66797 9.9375 7.1875 9.9375H16.8008L13.4023 13.3359C13.0352 13.7031 13.0352 14.2969 13.4023 14.6602C13.7695 15.0234 14.3633 15.0273 14.7266 14.6602L19.7266 9.66406ZM6.5625 2.125C7.08203 2.125 7.5 1.70703 7.5 1.1875C7.5 0.667969 7.08203 0.25 6.5625 0.25H3.4375C1.53906 0.25 0 1.78906 0 3.6875V14.3125C0 16.2109 1.53906 17.75 3.4375 17.75H6.5625C7.08203 17.75 7.5 17.332 7.5 16.8125C7.5 16.293 7.08203 15.875 6.5625 15.875H3.4375C2.57422 15.875 1.875 15.1758 1.875 14.3125V3.6875C1.875 2.82422 2.57422 2.125 3.4375 2.125H6.5625Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7801e9fdd557236de57872b4f6df09ac.svg";
export { ForwardRef as ReactComponent };